module.exports = __webpack_public_path__ + "static/media/GAOFEN 3.f445baf1.czml";